import components from './components'
import computed from './computed'
import data from './data'
import mounted from './mounted'
import methods from './methods'
import watch from './watch'
import validations from './validations'

export default {
  components,
  computed,
  data,
  methods,
  mounted,
  watch,
  validations
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/index.js